import React, { useState, useEffect } from 'react';
import api from '../api';

// Nastavenie hesla cez jednorazový token z e‑mailu (po aktivácii firmy).
// Token sa číta z query string: /set-password?token=...
export default function SetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) { setChecking(false); setValid(false); return; }
    api.get(`/auth/set-password/${token}`)
      .then(res => { setValid(!!res.data?.valid); setEmail(res.data?.email || ''); })
      .catch(() => setValid(false))
      .finally(() => setChecking(false));
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Heslo musí mať aspoň 8 znakov.'); return; }
    if (password !== password2) { setError('Heslá sa nezhodujú.'); return; }
    setSubmitting(true);
    try {
      await api.post('/auth/set-password', { token, password });
      setDone(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Heslo sa nepodarilo nastaviť.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="/mgtech-logo.png" alt="mG.tech" style={{ maxHeight: '90px', maxWidth: '280px', objectFit: 'contain', display: 'block', margin: '0 auto 0.75rem' }} />
          <h1 style={{ margin: 0, color: '#1f2937', fontSize: '1.35rem' }}>Nastavenie hesla</h1>
        </div>

        {checking ? (
          <p style={{ textAlign: 'center', color: '#6b7280' }}>Overujem odkaz…</p>
        ) : done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✅</div>
            <p style={{ color: '#16a34a', fontWeight: 600 }}>Heslo nastavené!</p>
            <a href="/login" style={{ ...btn, display: 'inline-block', textDecoration: 'none', marginTop: '0.5rem' }}>Prihlásiť sa</a>
          </div>
        ) : !valid ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#dc2626' }}>Odkaz je neplatný alebo expiroval.</p>
            <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Napíšte nám na <a href="mailto:hello@schvalovaniefaktur.sk">hello@schvalovaniefaktur.sk</a> a pošleme nový.</p>
          </div>
        ) : (
          <>
            {email && <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.9rem', marginTop: 0 }}>Účet: <strong>{email}</strong></p>}
            {error && (
              <div style={{ backgroundColor: '#fee2e2', color: '#dc2626', padding: '0.75rem', borderRadius: '4px', marginBottom: '1rem', fontSize: '0.9rem' }}>
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <label style={lbl}>Nové heslo (min. 8 znakov)</label>
              <input style={input} type="password" required value={password} onChange={e => setPassword(e.target.value)} />
              <label style={lbl}>Zopakujte heslo</label>
              <input style={input} type="password" required value={password2} onChange={e => setPassword2(e.target.value)} />
              <button type="submit" disabled={submitting}
                style={{ ...btn, width: '100%', marginTop: '1rem', opacity: submitting ? 0.6 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }}>
                {submitting ? 'Nastavujem…' : 'Nastaviť heslo'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

const wrap: React.CSSProperties = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6', padding: '1rem' };
const card: React.CSSProperties = { backgroundColor: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' };
const lbl: React.CSSProperties = { display: 'block', marginBottom: '0.25rem', marginTop: '0.5rem', color: '#374151', fontSize: '0.85rem' };
const input: React.CSSProperties = { width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' };
const btn: React.CSSProperties = { padding: '0.75rem', backgroundColor: '#2563eb', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer' };
